import axios from 'axios'
import { pathOr } from 'ramda'
import URLSearchParams from 'url-search-params'
import {
  SEARCH_PARAM_AMENITIES,
  SEARCH_PARAM_DATE_END,
  SEARCH_PARAM_DATE_START,
  SEARCH_PARAM_HOTEL_TYPE,
  SEARCH_PARAM_PRICE_RANGE,
  SEARCH_PARAM_ROOM,
  SEARCH_PARAM_SORT,
} from './components/search/constants'

/**
 * Update push block hotels
 */

const dataTemplate = [
  {
    price: '£75.23',
    oldPrice: '£175.23',
    discount: {
      price: null,
    },
    from: '',
    negotiated: null,
    id: '438',
    reserveBtn: 'Change my dates',
    reserveBtnUnavailable: 'Change my dates',
    reserveBtnForMoblie: 'Show prices',
    unavailableText: 'No apartment available for these dates',
    available: false,
  },
  {
    price: '£75.23',
    oldPrice: '',
    discount: {
      price: null,
    },
    from: '',
    negotiated: null,
    id: '404',
    reserveBtn: 'Change my dates',
    reserveBtnUnavailable: 'Change my dates',
    reserveBtnForMoblie: 'Show prices',
    unavailableText: 'No apartment available for these dates',
    available: false,
  },
  {
    price: '£75.23',
    oldPrice: '',
    discount: {
      price: null,
    },
    from: 'From',
    subPrice: 'Price for 1 night',
    negotiated: null,
    id: '373',
    reserveBtn: 'Choose an apartment',
    reserveBtnUnavailable: 'Change my dates',
    reserveBtnForMoblie: 'Choose an apartment',
    unavailableText: '',
    available: true,
  },
]

export default () => {
  const apiUrl = pathOr(null, ['drupalSettings', 'widgets', 'filters', 'submit', 'updatePushBlockUrl'], window)
  if (apiUrl === null) {
    console.error('No api URL in drupalSettings.widgets.filters.submit.updatePushBlockUrl')
    return
  }

  const hotelPushesContainer = document.querySelector('#hotel-block-pushes')
  if (!hotelPushesContainer) return

  const params = new URLSearchParams(window.location.search)
  const formData = new FormData()
  const hotelPushes = hotelPushesContainer.querySelectorAll('[data-hotel-id]')
  const hotelPushesIds = []

  hotelPushes.forEach((item) => {
    hotelPushesIds.push(item.getAttribute('data-hotel-id'))
  })

  if (params.has(SEARCH_PARAM_DATE_START) && params.has(SEARCH_PARAM_DATE_END)) {
    const dateStart = params.get(SEARCH_PARAM_DATE_START)
    const dateEnd = params.get(SEARCH_PARAM_DATE_END)
    let priceRangeParam = ''
    let amenitiesParam = ''
    let hotelTypeParam = ''
    let sortParam = ''
    let roomsParams = ''
    const apartments = []

    if (params.has(SEARCH_PARAM_PRICE_RANGE)) {
      priceRangeParam = params.get(SEARCH_PARAM_PRICE_RANGE)
    }
    if (params.has(SEARCH_PARAM_AMENITIES)) {
      amenitiesParam = params.get(SEARCH_PARAM_AMENITIES)
    }
    if (params.has(SEARCH_PARAM_HOTEL_TYPE)) {
      hotelTypeParam = params.get(SEARCH_PARAM_HOTEL_TYPE)
    }
    if (params.has(SEARCH_PARAM_SORT)) {
      sortParam = parseInt(params.get(SEARCH_PARAM_SORT), 10)
    }

    const paramsV3 = {
      dateIn: dateStart,
      nights: dateEnd,
      price_range: priceRangeParam,
      amenities: amenitiesParam,
      hotel_type: hotelTypeParam,
      sort: sortParam,
      prefCodes: '',
    }
    // append apartments to params
    if (params.has(SEARCH_PARAM_ROOM) && params.get(SEARCH_PARAM_ROOM) !== '') {
      roomsParams = params.getAll(SEARCH_PARAM_ROOM)
      roomsParams.forEach((room) => {
        const r = room.split(',')
        apartments.push(r)
        formData.append('params[apartment[]]', r)
      })
    }

    // append params to formdata
    Object.entries(paramsV3).forEach(
      ([key, value]) => {
        formData.append(`params[${key}]`, value)
      },
    )
    // append hotels id to formdata
    hotelPushesIds.forEach((id) => {
      formData.append('hotelsCodes[]', id)
    })
    axios.post(apiUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((response) => {
      response.data.availabilities.forEach((item) => {
        const pushBlock = document.querySelector(`[data-hotel-id="${item.id}"]`)
        /*
        * Price block twig structure
        * docroot/modules/custom/adagio_hotel/templates/
        *    adagio-hotel-referenced-hotels-item.html.twig
        * 3col__sales-discount
        * slider-3col__tooltip slider-3col__tooltip_empty
        * slider-3col__cash slider-3col__cash_empty
        *   slider-3col__cash-text (from)
        *   slider-3col__cash-price
        *   slider-3col__cash-old
        *
        * slider-3col__ft--right a
        * */
        const discount = pushBlock.querySelector('.slider-3col__sales-discount')
        const cashBlock = pushBlock.querySelector('.slider-3col__cash')
        const fromText = pushBlock.querySelector('.slider-3col__cash-text')
        const price = pushBlock.querySelector('.slider-3col__cash-price')
        const priceOld = pushBlock.querySelector('.slider-3col__cash-old')
        const btn = pushBlock.querySelector('.slider-3col__ft--right a')

        if (item.price.length > 1) {
          cashBlock.classList.remove('slider-3col__cash_empty')
          discount.innerHTML = item.discount.price
          fromText.innerHTML = item.from
          price.innerHTML = item.price
          priceOld.innerHTML = item.oldPrice
        } else {
          cashBlock.classList.add('slider-3col__cash_empty')
        }

        if (item.available) {
          btn.innerHTML = item.reserveBtnForMoblie
        } else {
          btn.innerHTML = item.reserveBtnUnavailable
        }
      })
    })
  }
}
